import React, { useEffect, useState } from "react";
import ScrollToTop from "../../../commons/ScrollToTop";
import { ErrorSuccessModal, TableHeader, TableLoader } from "../../../commons";
import { BILL_OF_MATERIAL_INVOICES_LIST_HEADERS } from "../../../../constant/tableHeadersConstants/invoiceGenerationConstants/invoicesListConst";
import { connect } from "react-redux";
import { BomDataListPayloadType } from "../../../../commonTypes/invoiceGenerationTypes";
import {
  getBomDataAction,
  resetBomDataList,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetSingleBomData,
} from "../../../../redux/invoiceGeneration";
import { RootState } from "../../../../redux/rootReducers";
import {
  BomDataItemType,
  BomDataType,
  FilterDataType,
} from "../../../../redux/invoiceGeneration/invoiceGenrationTypes";
import BomListTableData from "./BomListTableData";
import { resetSession } from "../../../../redux/auth";
import { SearchIcon } from "../../../Icon";
import useDebounce from "../../../../customHooks/useDebounce";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import Filter from "../BillOfMaterialFilter/Filter";
import Sorting from "../BillOfMaterialSorting/Sorting";
import { BusinessAddressListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { SelectOption } from "../../../../commonTypes/billOfMaterial";
import { GetAllStockItemListPayloadType } from "../../../../commonTypes/clientSettingsTypes";
import {
  getAllStockItemListAction,
  resetStockItemList,
  resetStockItemListTotal,
} from "../../../../redux/clientSettings";
import toast from "react-hot-toast";
import LockEntryModal from "../../LockEntryModal/LockEntryModal";
import DownloadManufacturalJournalReport from "../ManufacturalJournalReport";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";


type AppProps = {
  token: string | null;
  client_code: number;
  history: any;
  company_name: string;
  currencySign: string | undefined;
  bomListData: BomDataType;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  businessAddressList: [] | BusinessAddressListType[];
  message: string | null;
  isAddManufacturingPresent: boolean;
  isEditManufacturingPresent: boolean;
  allStockItemList: any;
  stockItemListTotal: number;
  stockFetching: boolean;
  dispatchResetSession: () => void;
  dispatchResetStockItemList: () => void;
  dispatchResetStockItemTotal: () => void;
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) => void;
  dispatchResetBomSingleDataAction: () => void;
  dispatchResetError: () => void;
  dispatchResetBomDataAction: () => void;
  dispatchGetBomDataAction: (data: BomDataListPayloadType) => void;
  handleSubmitBomLockEntry:(data:string)=>void;
  lockBOMEntriesDate:null|string;
  dispatchResetInvoiceGenerationError:()=>void;
  dispatchResetInvoicingSuccess:()=>void;
};

const BomInvoicesList = ({
  fetching,
  success,
  error,
  message,
  statusCode,
  currencySign,
  isEditManufacturingPresent,
  dispatchResetSession,
  dispatchGetAllStockItem,
  dispatchResetBomSingleDataAction,
  dispatchResetError,
  allStockItemList,
  client_code,
  history,
  company_name,
  bomListData,
  token,
  stockItemListTotal,
  stockFetching,
  dispatchGetBomDataAction,
  dispatchResetBomDataAction,
  dispatchResetStockItemList,
  dispatchResetStockItemTotal,
  handleSubmitBomLockEntry,
  lockBOMEntriesDate,
  dispatchResetInvoiceGenerationError,
  dispatchResetInvoicingSuccess
}: AppProps) => {
  const persistInvoiceSearch = history?.location?.state?.searchBillOfMaterial;
  const persistFilter = history?.location?.state?.filterBillOfMaterial;
  const persistSorting = history?.location?.state?.sortingBillOfMaterial;

  const [searchData, setSearchData] = useState<string>(persistInvoiceSearch);
  const [finalStockItemOptions, setFinalStockItemOptions] = useState<
    SelectOption[] | []
  >([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<BomDataItemType[] | []>([]);
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  const [sortingData, setSortingData] = useState<string>(
    !!persistSorting ? persistSorting : ""
  );
  const [filterData, setFilterData] = useState<FilterDataType>(
    !!persistFilter
      ? persistFilter
      : { primaryItem: { label: "Select Item...", value: null } }
  );
  const [selectedFilterData, setSelectedFilterData] = useState<FilterDataType>(
    !!persistFilter
      ? persistFilter
      : { primaryItem: { label: "Select Item...", value: null } }
  );
  const [stockItemText, setStockItemText] = useState("");
  const [stockOffset, setStockOffset] = useState(0);
  const [stockLimit, setStockLimit] = useState(20);
  const [isLockBomPresent, setIsLockBomPresent] = useMenuCheck();
  const [isDownloadBomPresent, setIsDownloadBomPresent] = useMenuCheck();
  

  useEffect(() => {
    window.scrollTo(0, 0);
    toast.remove();
    setIsLockBomPresent("Lock Manufacturing Entries", "menu");
    setIsDownloadBomPresent("Download Manufacturing Entries", "menu");
    dispatchResetBomDataAction();
    dispatchResetBomSingleDataAction();
    dispatchResetError();
    dispatchResetStockItemList();
    dispatchResetStockItemTotal();
    dispatchResetInvoiceGenerationError()
    dispatchResetInvoicingSuccess()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (bomListData?.data?.length === 0) {
      setData([...bomListData?.data]);
    }
    if (offset === 0) {
      if (bomListData?.data?.length) {
        setData([...bomListData?.data]);
      }
    } else if (offset > 0) {
      setData((prv: any) => [...prv, ...bomListData?.data]);
    } else {
      setData([...bomListData?.data]);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomListData?.data]);

  useEffect(() => {
    if (token && client_code) {
      let splitedSortingData = sortingData?.split("#$#");

      let finalData = {
        clientCode: client_code,
        token,
        searchTerm: searchData,
        limit,
        offset,
        PrimaryItemIdFilter: selectedFilterData?.primaryItem?.value,
        // primaryItemName:sortingData
        sortBy: splitedSortingData[0],
        sortByValue: splitedSortingData[1],
      };
      if (offset < +bomListData?.total_count) {
        dispatchGetBomDataAction(finalData);
        setIsApiCall(true);
      } else if (
        (bomListData?.total_count === undefined ||
          +bomListData?.total_count === 0 ||
          bomListData?.total_count === "") &&
        offset === 0
      ) {
        dispatchGetBomDataAction(finalData);
        setIsApiCall(true);
      }
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  useEffect(() => {
    if (isApiCall) {
      let splitedSortingData = sortingData?.split("#$#");
      let finalData = {
        clientCode: client_code,
        token,
        searchTerm: searchData,
        limit,
        offset,
        PrimaryItemIdFilter: selectedFilterData?.primaryItem?.value,
        sortBy: splitedSortingData[0],
        sortByValue: splitedSortingData[1],
      };
      dispatchGetBomDataAction(finalData);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortingData]);

  useEffect(() => {
    if (token && stockItemListTotal) {
      if (stockOffset <= +stockItemListTotal) {
        let finalData = {
          token,
          client_code,
          limit: stockLimit,
          offset: stockOffset,
          searchTerm: stockItemText,
        };
        dispatchGetAllStockItem(finalData);
      }
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOffset]);

  const fetchNewStockData = () => {
    let finalData = {
      token,
      client_code,
      limit: stockLimit,
      offset: stockOffset,
      searchTerm: stockItemText,
    };
    dispatchGetAllStockItem(finalData);
  };

  useDebounce(
    () => {
      if (stockItemText) {
        fetchNewStockData();
      } else {
        let finalData = {
          token,
          client_code,
          limit: 20,
          offset: 0,
          searchTerm: "",
        };
        dispatchGetAllStockItem(finalData);
      }
    },
    500,
    [stockItemText]
  );

  useEffect(() => {
    if (allStockItemList?.length > 0) {
      let newAllStockItemOption = allStockItemList?.map((item: any) => {
        return {
          label: item?.stock_item_name,
          value: item?.stock_item_id,
          unit: item?.stock_unit_symbol,
          byProduct: item?.by_product,
          coProduct: item?.co_product,
          scrap: item?.scrap,
        };
      });

      if (stockOffset > 0) {
        setFinalStockItemOptions([
          ...finalStockItemOptions,
          ...newAllStockItemOption,
        ]);
      } else {
        setFinalStockItemOptions([...newAllStockItemOption]);
      }
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStockItemList]);

  const checkStockItemTypeBottom = () => {
    setStockOffset((prv: any) => prv + stockLimit);
  };

  const handleFilterInputChange = (data: any, type: string) => {
    if (type === "primaryItem") {
      setFilterData((prev: FilterDataType) => ({ ...prev, primaryItem: data }));
    }
  };

  const onScroll = () => {
    // if(!fetching){
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (
      offset < +bomListData?.total_count &&
      !fetching &&
      Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
    ) {
      if (bomListData?.data?.length > 0) {
        if (!fetching && offset < +bomListData?.total_count) {
          setOffset(offset + limit);
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomListData?.data]);

  const handleBomEdit = (data: any) => {
    dispatchResetBomSingleDataAction();
    history.push({
      pathname: `/invoice-generation/edit-manufacturing/${client_code}?type=manufacturing`,
      state: {
        client_code,
        company_name,
        searchBillOfMaterial: searchData,
        filterBillOfMaterial: selectedFilterData,
        sortingBillOfMaterial: sortingData,
        bom_id: data?.bom_id,
        is_lock:data?.is_lock

      },
    });
  };

  const handleRedirectToEditForm = (data: any) => {
    window.scrollTo(0, 0);

    dispatchResetBomSingleDataAction();
    history.push({
      pathname: `/invoice-generation/edit-manufacturing/${client_code}?type=manufacturing`,
      state: {
        client_code,
        company_name,
        searchBillOfMaterial: searchData,
        filterBillOfMaterial: selectedFilterData,
        sortingBillOfMaterial: sortingData,
        bom_id: data?.bom_id,
        is_lock:data?.is_lock

      },
    });
  };

  const fetchNewData = (searchValue: string) => {
    setOffset(0);
    let splitedSortingData = sortingData?.split("#$#");
    let finalData = {
      clientCode: client_code,
      token,
      searchTerm: searchValue,
      limit,
      offset: 0,
      PrimaryItemIdFilter: selectedFilterData?.primaryItem?.value,
      sortBy: splitedSortingData[0],
      sortByValue: splitedSortingData[1],
    };
    dispatchGetBomDataAction(finalData);
  };

  useDebounce(
    () => {
      if (searchData) {
        fetchNewData(searchData);
      } else {
        if (isApiCall) {
          let splitedSortingData = sortingData?.split("#$#");
          setOffset(0);
          let finalData = {
            clientCode: client_code,
            token,
            searchTerm: "",
            limit,
            offset: 0,
            PrimaryItemIdFilter: selectedFilterData?.primaryItem?.value,
            sortBy: splitedSortingData[0],
            sortByValue: splitedSortingData[1],
          };
          dispatchGetBomDataAction(finalData);
        }
      }
    },
    500,
    [searchData]
  );

  const handleFilter = (type: string) => {
    if (type === "Add") {
      setSelectedFilterData({ ...filterData });
    }
    let splitedSortingData = sortingData?.split("#$#");
    let finalData = {
      clientCode: client_code,
      token,
      searchTerm: searchData,
      limit,
      offset: 0,
      PrimaryItemIdFilter:
        type === "Clear" ? null : filterData?.primaryItem?.value,
      sortBy: splitedSortingData[0],
      sortByValue: splitedSortingData[1],
    };

    dispatchGetBomDataAction(finalData);
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
      
      
    }
    if (success === 1 && message?.includes("Manufacturing Journal has been locked")) {
     dispatchResetBomDataAction();
     dispatchResetError();
     dispatchResetInvoiceGenerationError()
     dispatchResetInvoicingSuccess()
      toast.success("Manufacturing Journal has been locked", {
        duration: 2000,
      });
  
      if (token) {
        let splitedSortingData = sortingData?.split("#$#");
    let finalData = {
      clientCode: client_code,
      token,
      searchTerm: searchData,
      limit,
      offset: 0,
      PrimaryItemIdFilter: selectedFilterData?.primaryItem?.value,
      sortBy: splitedSortingData[0],
      sortByValue: splitedSortingData[1],
    }
     
          dispatchGetBomDataAction(finalData);
      }
    }
  };

  return (
    <div>
      <div className="col-md-12">
        <div className="row d-flex justify-content-between">
          <div className="col-md-4">
            <h6 style={{ margin: 0, fontSize: "18px", fontWeight: 500 }}>
              Manufacturing Journal
            </h6>
            {!fetching && (
              <span
                style={{ color: "#7c8db0", fontSize: "13px", fontWeight: 500 }}
              >
                Total {bomListData?.total_count} entries found
              </span>
            )}
          </div>

          <div className="col-md-8 d-flex justify-content-end">
            <div className="mr-3 w-auto position-relative">
              <span style={{ position: "absolute", top: "8px", left: "13px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                value={searchData}
                placeholder="Search"
                onChange={(e: any) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
              />
            </div>

            <div className="mr-2">
              <Filter
                handleFilter={handleFilter}
                setOffset={setOffset}
                filterData={filterData}
                handleFilterInputChange={handleFilterInputChange}
                allStockItemOption={finalStockItemOptions}
                fetching={stockFetching}
                setStockItemText={setStockItemText}
                checkStockItemTypeBottom={checkStockItemTypeBottom}
                setFilterData={setFilterData}
                selectedFilterData={selectedFilterData}
                setSelectedFilterData={setSelectedFilterData}
              />
            </div>

            <div className="mr-2">
              <Sorting
                setOffset={setOffset}
                sortingData={sortingData}
                setSortingData={setSortingData}
              />
            </div>
            {isDownloadBomPresent ? (
              <div className="mr-1">
              <DownloadManufacturalJournalReport
                clientCode={client_code}
                token={token}
              />
            </div>
            ) : null}
            {isLockBomPresent? (
              <div className="ml-1">
                <LockEntryModal
                  handleSubmitLockEntry={handleSubmitBomLockEntry}
                  lockedEntriesDate={lockBOMEntriesDate}
                />
              </div>
            ) :null}
          </div>
        </div>
      </div>
      {fetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      ) : (
        <div className="jobsType" style={{ overflowX: "auto" }}>
          <table className="table table-bordered thead-light">
            <thead
              className="text-start sticky-table-header"
              style={{ fontSize: "13px" }}
            >
              <TableHeader
                tableHeader={BILL_OF_MATERIAL_INVOICES_LIST_HEADERS}
                extraHeader
              />
            </thead>
            <tbody>
              <BomListTableData
                tableHeader={BILL_OF_MATERIAL_INVOICES_LIST_HEADERS}
                bomListData={data}
                currencySign={currencySign}
                handleBomEdit={handleBomEdit}
                isEditManufacturingPresent={isEditManufacturingPresent}
                lockBOMEntriesDate={lockBOMEntriesDate}
                handleRedirectToEditForm={handleRedirectToEditForm}

              />
              <ScrollToTop />
              {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            </tbody>
          </table>
          {handleErrorModal()}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  statusCode: state.invoiceGeneration.statusCode,
  error: state.invoiceGeneration.error,
  message: state.invoiceGeneration.message,
  businessAddressList: state.clientSettings.businessAddressList,
  bomListData: state.invoiceGeneration.bomListData,
  currencySign: state.auth.currencySign,
  allStockItemList: state.clientSettings.allStockItemList,
  stockFetching: state.clientSettings.fetching,
  stockItemListTotal: state.clientSettings.stockItemListTotal,
  lockBOMEntriesDate: state.invoiceGeneration.lockBOMEntriesDate,


});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetBomDataAction: (data: BomDataListPayloadType) =>
    dispatch(getBomDataAction(data)),
  dispatchResetBomDataAction: () => dispatch(resetBomDataList()),
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) =>
    dispatch(getAllStockItemListAction(data)),
  dispatchResetSessionAction: () => dispatch(resetSession()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetStockItemList: () => dispatch(resetStockItemList()),
  dispatchResetStockItemTotal: () => dispatch(resetStockItemListTotal()),
  dispatchResetError: () => dispatch(resetInvoiceGenerationError()),
  dispatchResetBomSingleDataAction: () => dispatch(resetSingleBomData()),
  dispatchResetInvoiceGenerationError: () =>
    dispatch(resetInvoiceGenerationError()),
    dispatchResetInvoicingSuccess: () =>
      dispatch(resetInvoiceGenerationSuccess()),
   
});

export default connect(mapStateToProps, mapDispatchToProps)(BomInvoicesList);
